import { Header } from '~/components/Header/Header';
import { Fragment } from 'react/jsx-runtime';
import { Outlet } from 'react-router';

export function Layout() {
  return (
    <Fragment>
      <Header />
      <Outlet />
    </Fragment>
  );
}
